import produce from "immer";
import axios from "axios";
import { setAppProcessing, setAppSuccess, setAppError } from "../lib/common";
import strings from "../res/strings";

export const CREATE_ITEM_LISTING = "luxurySeller/CREATE_ITEM_LISTING";
export const UPDATE_ITEM_LISTING = "luxurySeller/UPDATE_ITEM_LISTING";
export const DELETE_ITEM_LISTING = "luxurySeller/DELETE_ITEM_LISTING";
export const RETRIEVE_ITEM_LISTINGS = "luxurySeller/RETRIEVE_ITEM_LISTINGS";

const CREATE_ITEM_LISTING_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};

const UPDATE_ITEM_LISTING_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};

const DELETE_ITEM_LISTING_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};

const RETRIEVE_ITEM_LISTING_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};

const initialState = {};

export default (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case CREATE_ITEM_LISTING: {
        break;
      }

      case UPDATE_ITEM_LISTING: {
        break;
      }

      case DELETE_ITEM_LISTING: {
        break;
      }

      case RETRIEVE_ITEM_LISTINGS: {
        break;
      }

      default: {
        break;
      }
    }
  });

export const createItemListing = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "luxurySeller.createItemListing",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_LUXURY_CREATE_ITEM_LISTING,
        values
      )
      .then((response) => {
        dispatch({ type: CREATE_ITEM_LISTING });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? { context: "luxurySeller.createItemListing" },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = CREATE_ITEM_LISTING_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context: "luxurySeller.createItemListing",
                  notificationType: "alert",
                },
            history
          )
        );
      });
  };
};

export const updateItemListing = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "luxurySeller.updateItemListing",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_LUXURY_UPDATE_ITEM_LISTING,
        values
      )
      .then((response) => {
        dispatch({ type: UPDATE_ITEM_LISTING });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "luxurySeller.updateItemListing",
                },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = UPDATE_ITEM_LISTING_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context: "luxurySeller.updateItemListing",
                  notificationType: "alert",
                },
            history
          )
        );
      });
  };
};

export const deleteItemListing = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "luxurySeller.deleteItemListing",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_LUXURY_DELETE_ITEM_LISTING,
        values
      )
      .then((response) => {
        dispatch({ type: DELETE_ITEM_LISTING });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? { context: "luxurySeller.deleteItemListing" },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = DELETE_ITEM_LISTING_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context: "luxurySeller.deleteItemListing",
                  notificationType: "alert",
                },
            history
          )
        );
      });
  };
};

export const retrieveItemListings = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "luxurySeller.retrieveItemListings",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_LUXURY_RETRIEVE_ITEM_LISTINGS,
        values
      )
      .then((response) => {
        dispatch({ type: RETRIEVE_ITEM_LISTINGS });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? { context: "luxurySeller.retrieveItemListing" },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = RETRIEVE_ITEM_LISTING_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context: "luxurySeller.retrieveItemListing",
                  notificationType: "alert",
                },
            history
          )
        );
      });
  };
};
